<template>
	<div class="top-loadbar"></div>
</template>

<style>
:root {
	--top-loadbar-duration: 10s;
	--top-loadbar-color: var(--color-line-primary-1);
}

.top-loadbar {
	background: var(--top-loadbar-color);
	width: 0;
	height: 4px;
	position: absolute;
	top: 0;
	left: 0;

	animation: top-loadbar var(--top-loadbar-duration) forwards;
}

@keyframes top-loadbar {
	from {
		/* fix render pixels */
		width: 4px;
	}
	4% {
		width: calc(4%);
	}
	5% {
		width: 5%;
	}
	to {
		width: 95%;
	}
}
</style>
